import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20bright%20modern%20minimalist%20workspace%20with%20a%20sleek%20laptop%20displaying%20colorful%20spreadsheet%20dashboard%20with%20vibrant%20charts%20bar%20graphs%20and%20data%20visualization%20panels%2C%20surrounded%20by%20a%20matte%20white%20ceramic%20coffee%20cup%20a%20small%20green%20succulent%20in%20a%20cream%20terracotta%20pot%20and%20a%20clean%20notebook%2C%20soft%20warm%20morning%20sunlight%20streaming%20through%20floor%20to%20ceiling%20windows%20with%20sheer%20white%20curtains%2C%20warm%20cream%20beige%20and%20soft%20sage%20green%20color%20palette%2C%20airy%20spacious%20atmosphere%20with%20clean%20lines%20and%20gentle%20shadows%2C%20editorial%20lifestyle%20photography%20with%20shallow%20depth%20of%20field%20and%20refined%20harmonious%20composition&width=1600&height=900&seq=hero-vigorbuy-new-v2-2026&orientation=landscape"
          alt="Vigorbuy Spreadsheet modern workspace with data visualization"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-8">
          <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
          <span className="text-xs font-medium text-white/90 tracking-wide">2026 Complete Resource Hub</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white leading-tight mb-6">
          Vigorbuy Spreadsheet: Powerful<br className="hidden md:block" />
          Solutions For Smarter Business
        </h1>

        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          Discover professional spreadsheet templates, productivity guides, expert reviews, and comprehensive resources. Your complete guide to mastering Vigorbuy Spreadsheet for business growth and efficiency.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-xl text-base font-semibold bg-primary-500 text-white hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-shopping-bag-3-line text-lg"></i>
            Vigorbuy Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-xl text-base font-semibold bg-white text-foreground-950 hover:bg-background-100 transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-flashlight-line text-lg"></i>
            Buy It Now
          </a>
        </div>

        <div className="mt-10">
          <Link
            to="/vigorbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 text-sm text-white/70 hover:text-white transition-colors cursor-pointer group"
          >
            <i className="ri-book-open-line"></i>
            <span>Read the Complete Vigorbuy Spreadsheet Guide</span>
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
          </Link>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}